import { css, Global, useTheme } from '@emotion/react';

export function GlobalStyles() {
  const theme = useTheme();

  return (
    <Global
      styles={css`
        *,
        *::before,
        *::after {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        html {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        body {
          font-family:
            'Rubik',
            -apple-system,
            system-ui,
            'Segoe UI',
            Helvetica,
            Arial,
            sans-serif;
          background-color: ${theme.colors.background};
          color: ${theme.colors.text};
          line-height: 1.5;
        }

        a {
          color: inherit;
          text-decoration: none;
        }

        button,
        input,
        select,
        textarea {
          font: inherit;
          color: inherit;
        }

        button {
          background: none;
          border: none;
          cursor: pointer;
        }

        ul,
        ol {
          list-style: none;
        }

        img {
          display: block;
          max-width: 100%;
        }

        :focus-visible {
          outline: 2px solid #fa7faa;
          outline-offset: 2px;
        }

        :focus:not(:focus-visible) {
          outline: none;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .fade-in {
          animation: fadeIn 0.2s ease-out;
        }

        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border-width: 0;
        }
      `}
    />
  );
}
